// 站点栏目与文章盘点数据（公共占位 · 观察类内容，不针对具体真人编造负面信息）
export const siteMeta = {
  brand: "每日黑料",
  en: "DAILY SCOOP",
  tagline: "人物动态 · 热议盘点 · 看点观察",
  desc: "每日黑料是一个面向大众的公众人物动态与热议话题盘点站，持续收录明星、网红、商界人物与公共人物的高低起伏，以严谨核实的态度呈现人物内幕、行业走向与议题观察。",
  email: "editor@example.com",
  icp: "本站为内容聚合演示站点",
};

export interface Category {
  key: string;
  name: string;
  en: string;
  desc: string;
  image: string;
}

export const categories: Category[] = [
  {
    key: "star",
    name: "明星盘点",
    en: "STAR FILE",
    desc: "镜头前后的人物长镜头与营业观察，记录台前幕后的起落与分寸。",
    image:
      "https://readdy.ai/api/search-image?query=vintage%20editorial%20portrait%20of%20a%20stage%20performer%20silhouette%20standing%20in%20a%20warm%20golden%20spotlight%20cone%2C%20gentle%20confetti%20falling%2C%20warm%20ivory%20newsprint%20paper%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20ink%20accents%2C%20vintage%20halftone%20dots%2C%20grainy%20retro%20offset%20print%20texture%2C%20dramatic%20chiaroscuro%2C%20high%20contrast%20tabloid%20art%20direction&width=720&height=720&seq=cat-tile-star&orientation=squarish",
  },
  {
    key: "wanghong",
    name: "网红生态",
    en: "CREATOR",
    desc: "流量浪潮中内容创作者的口碑沉浮，梳理网红经济下半场的内容逻辑。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20concept%20collage%20of%20a%20modern%20broadcast%20microphone%20next%20to%20a%20smartphone%20glowing%20with%20live%20stream%20icons%2C%20abstract%20signal%20waves%2C%20warm%20ivory%20paper%20texture%2C%20bold%20crimson%20and%20amber%20ink%2C%20vintage%20halftone%20pattern%2C%20grainy%20retro%20print%20grain%2C%20minimal%20magazine%20composition%20with%20negative%20space&width=720&height=720&seq=cat-tile-wanghong&orientation=squarish",
  },
  {
    key: "shangjie",
    name: "商界人物",
    en: "BUSINESS",
    desc: "聚光灯下企业家与创业者的人物侧写，围观商业世界的进退抉择。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20an%20abstract%20executive%20silhouette%20in%20a%20sharp%20suit%20holding%20a%20briefcase%20before%20a%20skyline%20of%20geometric%20buildings%2C%20warm%20ivory%20newsprint%20background%2C%20deep%20crimson%20and%20amber%20gold%20ink%2C%20vintage%20halftone%2C%20grainy%20offset%20print%2C%20dramatic%20lighting%2C%20wide%20minimal%20magazine%20art%20direction&width=720&height=720&seq=cat-tile-shangjie&orientation=squarish",
  },
  {
    key: "gonggong",
    name: "公共人物",
    en: "PUBLIC",
    desc: "公共场域发言与行为边界的议题盘点，探讨影响力与责任的关系。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20hand%20holding%20a%20vintage%20brass%20megaphone%20releasing%20radiating%20sound%20lines%20over%20a%20quiet%20crowd%20silhouette%2C%20warm%20ivory%20newsprint%20background%2C%20bold%20crimson%20and%20amber%20ink%2C%20vintage%20halftone%20dots%2C%20grainy%20retro%20offset%20print%2C%20dramatic%20high%20contrast%2C%20minimal%20magazine%20art&width=720&height=720&seq=cat-tile-gonggong&orientation=squarish",
  },
];

export interface Article {
  slug: string;
  catKey: string;
  catName: string;
  title: string;
  lead: string;
  date: string;
  views: string;
  tags: string[];
  cover: string;
  body: string[];
}

export const articles: Article[] = [
  {
    slug: "gongye-yingye",
    catKey: "star",
    catName: "明星盘点",
    title: "镜头之外的营业图鉴：明星与公众之间的真实边界",
    lead: "当作品与私生活同时被放大检视，公众究竟该以怎样的距离，去认识一个被反复观看的人。",
    date: "2026-09-08",
    views: "128.6万",
    tags: ["营业观察", "人物长镜头", "边界讨论"],
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20feature%20art%20of%20a%20lone%20figure%20under%20a%20bright%20circular%20stage%20spotlight%20with%20golden%20curtains%20at%20the%20edges%2C%20warm%20ivory%20newsprint%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20ink%20accents%2C%20vintage%20halftone%20dots%2C%20grainy%20offset%20printing%20grain%2C%20dramatic%20chiaroscuro%2C%20high%20contrast%20tabloid%20art%20direction%2C%20generous%20negative%20space&width=1200&height=675&seq=art-cover-gongye&orientation=landscape",
    body: [
      "在注意力经济的语境里，一个公众人物的「营业」早已不局限于作品本身。写真、综艺、直播、社交动态共同构成了被观看的连续文本，而观众也借此拼凑出一个「屏幕上的他」。可问题在于，屏幕内外的人是否真能被等同起来。",
      "我们习惯用几部作品、几次采访去定义一个长期活跃的人，这种「标签化」既高效也危险。它把人压缩成一句口号，一旦现实与标签错位，落差便成为舆论的燃料。盘点这些年的人设更迭，会发现多数争议并不源于作品，而源于预期与现实之间的缝隙。",
      "值得留意的是，越来越多从业者开始主动管理这份被观看的距离。他们不再把生活全盘托出，而是在作品与自我之间划出一道清醒的线：该展示的认真展示，属于私域的保持沉默。这种「边界意识」正被重新视为一种专业。",
      "从行业侧观察，片方与平台也在调整曝光策略。真人秀剪辑愈发讲究真实感而非冲突，团队更重视舆情前置与危机预案，说明行业逐渐意识到：观众要的并非永远完美的偶像，而是一个经得起反复观看、言行一致的长期主义者。",
      "说到底，明星与公众的关系从来不是单向的仰望，而是一场需要双向尊重的长跑。多给作品一点时间，少给人设一点想象，或许才是更成熟的相处方式。这也是本期「人物长镜头」想要探讨的起点。",
    ],
  },
  {
    slug: "liuliang-xiachang",
    catKey: "wanghong",
    catName: "网红生态",
    title: "流量退潮之后：认真做内容的人正在上岸",
    lead: "算法不再偏爱喧嚣，当哗众取宠的红利见底，真正留下来的是愿意长期打磨内容的人。",
    date: "2026-09-06",
    views: "96.3万",
    tags: ["内容价值", "网红下半场", "生态观察"],
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20concept%20collage%20of%20an%20upward%20trending%20arrow%20crossing%20over%20a%20modern%20broadcast%20microphone%2C%20faint%20rising%20and%20falling%20dot%20lines%20around%2C%20warm%20ivory%20paper%20texture%2C%20crimson%20and%20amber%20ink%2C%20halftone%20pattern%2C%20grainy%20retro%20print%2C%20minimal%20composition%20with%20negative%20space&width=1200&height=675&seq=art-cover-liuliang&orientation=landscape",
    body: [
      "直播电商与短视频在经历了爆发式增长后，正进入一个更冷静的阶段。平台流量见顶、投流成本抬升，单纯依靠猎奇标题与夸张表演获取的曝光，其转化率正在快速走低。喧嚣的红利期，正在被内容深耕期取代。",
      "一个明显的信号是，创作者生态开始「分层」。头部在品牌化与机构化，中腰部则在专业化与垂直化，而那些仍停留在「蹭热点、博眼球」单一路径的内容，正在被算法与用户双重冷落。哗众取宠的红利，已经肉眼可见地见底。",
      "真正留下来的人，往往做了同一件事：把「流量逻辑」换成了「信任逻辑」。他们减少无用互动、专注把选题做透，用持续稳定的内容供给建立辨识度。口碑带来的复利，远比一次性爆款更抗周期。",
      "品牌方的选人标准也在变化。比起单场GMV，越来越多品牌开始在意带货口碑、退换率与粉丝画像的匹配度。「翻车一次回到原点」的教训，让行业把风控前置到了合作之前，也让踏实主播获得更多议价空间。",
      "对内容创作者而言，这不是坏消息，而是一次重新定位的机会。当潮水退去，才知道谁在裸泳；也正因为潮水退去，认真游泳的人才终于被看见。网红经济的下半场，名字或许不再叫流量，而是叫内容本身。",
    ],
  },
  {
    slug: "juanguang-shangjie",
    catKey: "shangjie",
    catName: "商界人物",
    title: "聚光灯下的企业家：从高调发声到回归本业",
    lead: "企业家在公共话语中的角色正在被重新讨论，专注产品与经营，也许才是更稳健的长期主义。",
    date: "2026-09-04",
    views: "84.1万",
    tags: ["企业家", "经营哲学", "聚光灯"],
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20an%20abstract%20executive%20in%20a%20suit%20seen%20from%20behind%20facing%20a%20tall%20skyline%20of%20geometric%20buildings%2C%20oversized%20briefcase%2C%20warm%20ivory%20paper%20background%2C%20deep%20crimson%20and%20amber%20accents%2C%20vintage%20halftone%2C%20grainy%20print%2C%20dramatic%20lighting%2C%20wide%20composition&width=1200&height=675&seq=art-cover-shangjie&orientation=landscape",
    body: [
      "过去数年，个别企业家的高调言论屡屡登上热搜，把商业场活成了舆论场。但喧闹之后，公众的关注度并未自动转化为品牌好感，反而可能因一句不慎的发言，把多年积累的信誉拖入泥潭。这种「言多必失」的案例，正在让更多经营者重新掂量公共表达的分量。",
      "从经营视角看，创始人的公共形象本应是品牌的延伸资产，而不应是独立的表演舞台。真正支撑一家公司穿越周期的，永远是产品、现金流与组织能力，而非演讲与流量。当一家企业把精力过度倾斜到对外发声，往往意味着对内的失焦。",
      "今年以来的行业走向印证了这一判断：越来越多企业家主动选择「回归本业」，减少非必要的公开露脸，把时间还给研发与客户。表面看是低调，本质上是一种更成熟的风险管理——说得越少，被误读的可能就越低。",
      "当然，这不意味着企业家应当沉默。在面对就业、行业政策等公共议题时，负责任的发声仍有价值。关键在于「为谁发声、为何发声」——是从行业真实痛点出发的建设性表达，还是为个人影响力的刷存在感，公众其实分辨得清楚。",
      "一个健康的商业舆论环境，需要企业家用产品说话，也需要公众用平常心去看待每一次经营起伏。企业家的高光不该靠热搜维持，而应来自产品被市场长期选择的底气。聚光灯终会移走，留下的唯有实业的成色。",
    ],
  },
  {
    slug: "gonggong-yanxing",
    catKey: "gonggong",
    catName: "公共人物",
    title: "公共人物的言行边界：流量越大，责任越重",
    lead: "公共场域里没有真正的「随口一说」，影响力既是放大器，也是一份必须随身携带的克制。",
    date: "2026-09-02",
    views: "76.8万",
    tags: ["言行边界", "公共讨论", "责任"],
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20hand%20holding%20a%20vintage%20brass%20megaphone%20with%20radiating%20sound%20lines%2C%20overlapping%20speech%20bubbles%20rising%2C%20warm%20ivory%20newsprint%20background%2C%20bold%20crimson%20and%20amber%20halftone%20ink%2C%20grainy%20retro%20offset%20print%2C%20dramatic%20high%20contrast%2C%20minimal%20magazine%20art&width=1200&height=675&seq=art-cover-gonggong&orientation=landscape",
    body: [
      "当一个人站到公共话筒前，他的每句话都会被乘以粉丝数再放大回响。一句本无恶意的调侃，在层层转述后可能变成对他人的伤害；一次立场模糊的表态，也可能被不同阵营各自解读成支持己方的证据。这就是公共表达的放大效应。",
      "公共场域没有「私下」可言，可很多争议恰恰源于「把私下口吻带到了公开场合」。盘点近年引发讨论的事件，会发现相当比例并非行为失当，而是表达与场合的错配。说话的对象、场景与语境，本该是表达前最先确认的三件事。",
      "除了表达，行为边界同样值得审视。公共人物享有的资源与曝光，决定了他们难以真正退出公众视野；但这并不等于公众有权进入他们生活的每一个角落。尊重隐私与要求担责并不矛盾，真正的边界需要双方共同守护。",
      "面对争议，更有担当的做法是「及时、坦诚、就事论事」地回应，而不是用转移话题或情绪反制来拖延。公众的耐心有限，一次敷衍的危机公关，往往比事件本身更伤信任。负责任的公共人物懂得：解释清楚比解释漂亮更重要。",
      "我们谈论边界，不是为了给谁设限，而是为了让公共讨论更有质量。当每个人——无论名气大小——都把「我这句话会带来什么」想清楚，舆论场才不至于被情绪裹挟。影响力从来都是中性词，它是放大器还是伤害源，取决于握住它的人。",
    ],
  },
  {
    slug: "fanghong-laoshuren",
    catKey: "star",
    catName: "明星盘点",
    title: "老熟人回归潮：经典面孔为何再次翻红",
    lead: "在陌生内容泛滥的当下，观众的怀旧与信任，正把一批久违的经典面孔重新推回聚光灯中央。",
    date: "2026-08-28",
    views: "143.2万",
    tags: ["回归潮", "怀旧经济", "综艺观察"],
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20retro%20vintage%20television%20set%20emitting%20warm%20golden%20light%20with%20a%20glowing%20star%20above%20it%2C%20warm%20ivory%20paper%20background%2C%20crimson%20red%20and%20amber%20gold%20ink%2C%20vintage%20halftone%20dot%2C%20grainy%20film%20grain%2C%20nostalgic%20retro%20art%20direction&width=1200&height=675&seq=art-cover-fanhong&orientation=landscape",
    body: [
      "近期多个平台不约而同打出了「回忆杀」的牌：久未同框的组合重聚、经典剧集主演返场、老牌综艺以「重聚季」的姿态回归。一度被视作「过气」的熟悉面孔，正以出人意料的热度重新占据话题中心。",
      "这份热度并非偶然。在信息过载、新内容不断更替的环境里，观众反而更愿意为「确定性的熟悉感」买单。经典面孔承载的不仅是作品记忆，更是一段可以被集体回忆的情绪锚点。人们怀念的从来不是某个人，而是与之相关的旧时光。",
      "对内容方而言，这成了一门划算的生意：成熟的IP、自带情怀的艺人、已被验证过的叙事模板，让「回归」的试错成本远低于孵化新人。但风险也随之而来——如果回归只剩消费情怀、缺乏新的内容诚意，透支的反而是观众最后的耐心。",
      "真正成功的回归，往往是「熟悉感 + 新鲜感」的组合。让老面孔出现在全新的舞台设定里，或在旧IP中注入当下议题，才能把怀旧变成向前看的动力，而不是对过去的简单复刻。观众并不排斥重聚，他们排斥的是敷衍。",
      "老熟人翻红提醒行业一个朴素的道理：作品的寿命可以很长，长到足以跨越几个流行周期。与其不断追逐下一个爆点，不如认真打磨经得起时间检验的内容。经典面孔的再次发光，终究是认真创作的回声。",
    ],
  },
  {
    slug: "zhibo-koubei",
    catKey: "wanghong",
    catName: "网红生态",
    title: "翻车与自省：直播生态里的口碑重建样本",
    lead: "一次翻车并不必然是终点，如何道歉、如何整改、如何重新赢回信任，才是真正的修罗场。",
    date: "2026-08-22",
    views: "88.9万",
    tags: ["直播", "危机公关", "口碑重建"],
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20concept%20collage%20of%20a%20cracked%20pane%20of%20glass%20being%20repaired%20with%20golden%20adhesive%20lines%20and%20a%20small%20replanting%20sprout%20rising%2C%20warm%20ivory%20paper%20texture%2C%20crimson%20and%20amber%20ink%2C%20halftone%20grain%2C%20grainy%20offset%20print%2C%20hopeful%20dramatic%20mood%2C%20minimal%20composition&width=1200&height=675&seq=art-cover-chongjian&orientation=landscape",
    body: [
      "直播行业的公开化程度极高：卖货的佣金结构、话术的夸张尺度、售后处理的速度，几乎全程暴露在观众与监管的目光之下。也正因如此，「翻车」几乎成为每个头部直播间必经的压力测试，差别只在于翻车之后如何收场。",
      "复盘大量案例，口碑崩塌往往不是单点失误，而是「承认错误的姿势」出了问题。有的主播选择冷处理假装无事，有的用补偿转移焦点，还有的将责任推给选品或天气。越是闪躲，观众越能嗅到不诚恳，信任流失得也越快。",
      "口碑重建的第一步，是给出可被验证的整改，而非口头的道歉。公开溯源问题环节、引入第三方抽检、主动升级售后条款……这些落在纸面上的动作，比一百句「对不起」更有说服力。观众可以接受失误，但很难接受没有代价的失误。",
      "从更长周期看，一次负责任的处理反而可能成为信任的加固剂。经历过危机的直播间，若能在整改后持续兑现承诺，往往会获得更高的用户粘性——因为观众亲眼见证了它是如何被「考验」的。翻车本身不可怕，可怕的是一错再错。",
      "直播是信任的生意，而信任是世界上最需要时间、也最容不得侥幸的东西。重建口碑没有捷径，只有把每一次承诺都当成下一次复购的抵押，认真活下去的人，才配得上观众的长期停留。",
    ],
  },
  {
    slug: "chuangye-xinren",
    catKey: "shangjie",
    catName: "商界人物",
    title: "新一代创业者画像：慢下来，也是一种策略",
    lead: "不再迷信「烧钱换增长」，新一代创业者把现金管理与健康增长，写进了自己的创业守则。",
    date: "2026-08-16",
    views: "61.5万",
    tags: ["创业者", "新画像", "稳健增长"],
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20young%20entrepreneur%20standing%20at%20a%20crossroads%20of%20geometric%20paths%20under%20a%20warm%20sky%2C%20holding%20a%20briefcase%20and%20a%20seedling%2C%20warm%20ivory%20paper%2C%20crimson%20and%20amber%20halftone%20ink%2C%20grainy%20offset%20print%2C%20hopeful%20dramatic%20art%20direction&width=1200&height=675&seq=art-cover-chuangye&orientation=landscape",
    body: [
      "与上一代「先规模后盈利」的叙事不同，新一代创业者正在重写成功的定义。融资不再被视为唯一的荣耀，不少创始人主动放弃了高举高打，转而追求「小而美」的现金流生意，把活下去的确定性放在第一位。",
      "这种转变背后，是资本逻辑的深刻变化。当市场回归冷静，「估值游戏」不再是衡量创业价值的唯一标尺，投资人开始更在意单位经济模型与复购率。那些最早学会精打细算的团队，反而在新周期里拿到了最充足的议价空间。",
      "新画像里的创业者，往往同时是「产品人」和「经营者」。他们愿意为了一个体验细节反复打磨，也愿意亲自盯现金流报表。对他们而言，把用户当朋友、把成本当红线，比讲一个动人的融资故事要踏实得多。",
      "当然，慢下来不代表不敢冒险，而是把风险放在看得见的地方。稳健的创业者同样会拥抱新技术、尝试新渠道，只是每一步都有清晰的验证标准。这种「想清楚再All in」的方式，让创新建立在可承受的试错之上。",
      "创业从来不是百米冲刺，而是一场需要节奏感的马拉松。当越来越多的年轻人愿意先扎深再做大的时候，商业世界的底色或许会变得更健康——不追逐最快的增长，只追求最长的成长。",
    ],
  },
  {
    slug: "gongyi-tiaolun",
    catKey: "gonggong",
    catName: "公共人物",
    title: "当公众议题遇上热搜：理性讨论的几条准则",
    lead: "热搜让每一个议题都处在二十四小时聚光灯下，如何不被情绪裹挟，是每个参与者都要修的功课。",
    date: "2026-08-09",
    views: "54.2万",
    tags: ["热搜", "理性讨论", "公共议题"],
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20collage%20of%20overlapping%20speech%20bubbles%20and%20a%20rising%20sun%20over%20a%20quiet%20city%20skyline%20with%20dove%20silhouettes%2C%20warm%20ivory%20newsprint%2C%20crimson%20and%20amber%20ink%2C%20halftone%20grain%2C%20grainy%20vintage%20print%2C%20hopeful%20civic%20mood&width=1200&height=675&seq=art-cover-gongyi&orientation=landscape",
    body: [
      "热点事件在热搜上的生命周期往往以小时计，可议题背后的复杂性，却远非一条标题所能承载。当公众人物卷入争议，围观者首先面临的，是被情绪与立场推着走的冲动，以及冷静核对事实的耐心之间的拉扯。",
      "理性讨论的第一条准则，是「先让子弹飞一会儿」。事件初期信息往往残缺且互相矛盾，急于站队的结果，常是让真正的事实被情绪淹没。给核实留出时间，既是对当事人的负责，也是对自己判断力的尊重。",
      "第二条准则，是「就事论事，不搞诛心」。讨论一个行为是否得当，应聚焦行为本身与规则，而非动机猜度与人格否定。把一场具体的争议上升为对某个群体的全面攻讦，只会让真正的议题失焦，伤害本就脆弱的公共对话空间。",
      "第三条准则，是「承认信息的有限」。我们大多数人掌握的信息，远不足以还原全貌。保持一份「我可能不知道全部」的谦逊，愿意在真相更新后修正自己的观点，是一种难得的素养，也是公共讨论能够继续的前提。",
      "公共议题的价值，本在于通过讨论促成共识与进步，而不是制造对立与消耗。热搜有落幕的时候，但每一次讨论留下的，是更加成熟的舆论氛围，还是更加割裂的彼此，取决于身处其中的我们每一个人。",
    ],
  },
];